import { useState, useRef, useEffect } from "react";

interface SpeedMenuButtonProps {
    playerApiRef: any;
    speedOptions?: number[];
    cycleOnTap?: boolean;
}

const DEFAULT_SPEED_OPTIONS = [0.25, 0.5, 1, 1.25, 1.5, 2];

export const SpeedMenuButton = (props: SpeedMenuButtonProps) => {
    const { playerApiRef, cycleOnTap = false, speedOptions = DEFAULT_SPEED_OPTIONS } = props;
    const [currentSpeed, setCurrentSpeed] = useState(1.0);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null) as any;

    useEffect(() => {
        if (cycleOnTap) return;

        const handleClickOutside = (e: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, [cycleOnTap]);

    const applySpeed = (speed: number) => {
        const player = playerApiRef && playerApiRef.current;

        if (player) {
            player.playbackRate = speed;
        }

        setCurrentSpeed(speed);
    };

    const selectSpeed = (speed: number) => {
        applySpeed(speed);
        setIsMenuOpen(false);
    };

    const cycleSpeed = () => {
        const currentIndex = speedOptions.indexOf(currentSpeed);
        const nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % speedOptions.length;
        applySpeed(speedOptions[nextIndex]);
    };

    const onSpeedClick = () => {
        if (cycleOnTap) {
            cycleSpeed();
            return;
        }
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div className="speed-menu-btn" ref={menuRef} data-speed={currentSpeed}>
            <div className="speed-current" onClick={onSpeedClick}>
                {Number.isInteger(currentSpeed) ? currentSpeed.toFixed(1) : currentSpeed}
                <div className="x-sign">x</div>
            </div>

            {!cycleOnTap && isMenuOpen &&
                <div className="speed-options">
                    {speedOptions.map((speed) => (
                        <div key={speed} onClick={() => selectSpeed(speed)} className={`speed-option ${speed === currentSpeed ? "active" : ""}`} >
                            {Number.isInteger(speed) ? speed.toFixed(1) : speed}x
                        </div>
                    ))}
                </div>
            }
        </div>
    );
};
